import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {RoadKill} from "../RoadKill";
import {RoadKillGameMode} from "../server/RoadKillGameMode";
import {TimelineLite} from "gsap";
import {RoadKillSound} from "../sound/RoadKillSound";


export class RoadKillEnableMassiveWildRunner implements SimplePresentation {
    shouldRun(): boolean {
        return RoadKill.model.gameData.totalAnimalHitsSFS === 20 && RoadKill.model.nextMode === RoadKillGameMode.SUPER_FREESPIN;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: TimelineLite = new TimelineLite();
        tl.add(RoadKill.massiveWinView.darkenAllSym());
        tl.to(this, {duration: 0.5});
        tl.add(RoadKill.massiveWinView.updateHeartList());
        tl.to(this, {duration: 0.5});
        tl.add(RoadKill.massiveWinView.moveJWToPosition());
        tl.to(this, {duration: 0.5});
        tl.add([RoadKill.massiveWinView.showIndividualCover(), () => {
            RoadKill.soundPlayer.playTrack(RoadKillSound.TOTAL_ANIMAL_HIT);
        }]);
        tl.add(RoadKill.massiveWinView.setJumpingWildVisibility(false));
        tl.to(this, {duration: 0.3});
        tl.add(() => controller.finish());
    }

}